import { action } from 'mobx';

import { BooleanStore } from 'ui/base/input';

import { ResultKind } from 'services/base/types';
import { IPangolinDomain, VPNClient, VPNServer } from 'services/pangolin/types';
import { VPNServerService, VPNServerUpdateResult } from 'services/pangolin/vpn_server_service';
import { VPNClientService, VPNClientUpdateResult } from 'services/pangolin/vpn_clients_service';

export class VPNClientStore {
  enabled: BooleanStore;
  client: VPNClient;

  constructor(client: VPNClient) {
    this.client = client;
    this.enabled = new BooleanStore(client.isEnabled);
  }

  @action.bound
  async handleToggle(domain: IPangolinDomain): Promise<VPNClientUpdateResult> {
    if (domain.vpnClients.has(this.client.id)) {
      return await VPNClientService.update(domain, {
        id: this.client.id,
        isEnabled: this.enabled.value,
      });
    }

    return { kind: ResultKind.SYSTEM_ERROR };
  }
}

export class VPNServerStore {
  enabled: BooleanStore;
  server: VPNServer;

  constructor(server: VPNServer) {
    this.server = server;
    this.enabled = new BooleanStore(server.isEnabled);
  }

  @action.bound
  async handleToggle(domain: IPangolinDomain): Promise<VPNServerUpdateResult> {
    return await VPNServerService.update(domain, {
      isEnabled: this.enabled.value,
    });
  }
}
